<script lang="ts">
    
    import { SERVICE_URL } from "../../environment";
    import type { State } from "../../Model/State";

    export let id: State<string | null>;

    let pictureUrl: string;

    $: setupPictureId($id);

    function setupPictureId(pictureId: string | null): void {
        pictureUrl = pictureId
            ? new URL(`picture/${pictureId}`, SERVICE_URL).href
            : '/images/default-placeholder.png';
    }

    function setDefault() {
        pictureUrl = '/images/default-placeholder.png';
    }

</script>

<!-- svelte-ignore a11y-missing-attribute -->
<img src={pictureUrl} on:error={setDefault}>

<style lang="scss">

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

</style>
